import { createSelector } from 'reselect';
import { favouriteProductsStateSelector, favouriteProductIdsSelector, totalFavouritesLengthSelector, isLoadingFavouriteProductsSelector, isLoadingAllFavouriteProductIdsSelector } from 'swag-client-common/redux/favourite-products/favourite-products.selectors';
import { itemSelector, limitedEditionSelector } from '../../components/page/components/product-card/product-card.selectors';
import { addEdgePriceToProduct } from '../product-listing/product-listing.selectors';
import { productSelector } from '../product/product.selectors';
const productItemPropsSelector = (state, props) => props.item;
const checkProductIsFavourite = (product, favouriteProductIds) => {
  if (!product) {
    return false;
  }
  return favouriteProductIds.has(product._id);
};
export const isProductFavouriteSelector = createSelector(productItemPropsSelector, favouriteProductIdsSelector, checkProductIsFavourite);
export const productAtProductBuilderIsFavouriteSelector = createSelector(productSelector, favouriteProductIdsSelector, checkProductIsFavourite);
export const pageSelector = createSelector(favouriteProductsStateSelector, state => state.page);
export const favouriteProductsSelector = createSelector(favouriteProductsStateSelector, state => state.favouriteProducts.map(item => addEdgePriceToProduct(item)));
const isFavouriteProductsPageInitializedSelector = createSelector(favouriteProductsStateSelector, state => state.isFavouriteProductsPageInitialized);
export const hasFavouriteProductsSelector = createSelector(isLoadingAllFavouriteProductIdsSelector, favouriteProductIdsSelector, (isLoadingAllFavouriteProductIds, favouriteProductIds) => !isLoadingAllFavouriteProductIds && favouriteProductIds.size > 0);
export const shouldShowEmptyBlockSelector = createSelector(hasFavouriteProductsSelector, isFavouriteProductsPageInitializedSelector, (hasFavourites, isFavouriteProductsPageInitialized) => {
  return !hasFavourites && isFavouriteProductsPageInitialized;
});
export const hasMoreFavouriteProductsSelector = createSelector(isLoadingFavouriteProductsSelector, totalFavouritesLengthSelector, favouriteProductsSelector, (isLoadingAllFavouriteProductIds, allFavouriteProductIdsLength, favouriteProducts) => {
  return !isLoadingAllFavouriteProductIds && allFavouriteProductIdsLength > favouriteProducts.length;
});
export const showProductLabelSelector = createSelector(itemSelector, limitedEditionSelector, ({
  productLabel
}, {
  isLimitedEdition
}) => {
  return !isLimitedEdition && productLabel;
});